import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5fa28036"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mb-9" }, [
  /*#__PURE__*/_createTextVNode(" Increased buy limits "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" so you can do more with crypto ")
], -1))
const _hoisted_2 = { class: "elevated-box-small elevation-5 pa-lg-10 pa-7" }
const _hoisted_3 = { class: "heading-2 description-text mb-2" }
const _hoisted_4 = { class: "font-weight-medium description-title" }


export default /*#__PURE__*/_defineComponent({
  __name: 'PromoComponent',
  setup(__props) {

const promo1 = [
  {
    title: "For your first transaction",
    description:
      "If you are buying coins very first time, you can buy up to $20,000 worth of coins.",
    amount: "$50 to $20,000",
    rate: "for first buy",
  },
  {
    title: "Daily limit",
    description: "You can buy up to $20,000 worth of coins daily.",
    amount: "Up to $20,000",
    rate: "/day",
  },
  {
    title: "Monthly limit",
    description: "You can buy up to $50,000 worth of coins monthly.",
    amount: "Up to $50,000",
    rate: "/month",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", {
    class: "component--promo dropShadow",
    style: _normalizeStyle(_ctx.$vuetify.display.lgAndUp ? 'padding: 150px 0' : 'padding: 100px 0')
  }, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(promo1, (p1, key1) => {
                return _createVNode(_component_v_col, {
                  cols: "12",
                  md: "4",
                  key: key1
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(p1.amount), 1),
                      _createElementVNode("h2", _hoisted_4, _toDisplayString(p1.title), 1)
                    ])
                  ]),
                  _: 2
                }, 1024)
              }), 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 4))
}
}

})